import { Box, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import Atomic from "../../../../AComponent/Atomic";

const { Input, Button } = Atomic;

const nameMap = {
  A: "Annual",
};

const TargetsAndWeights = ({ targets, onDone }) => {
  const [data, setData] = useState(targets);

  const onChangeHandler = (value, type, index) => {
    setData((prevState) => {
      const newState = [...prevState];
      newState[index][type] = value;
      return newState;
    });
  };

  return (
    <Stack
      rowGap={"1rem"}
      height={"15rem"}
      width={"25rem"}
      alignItems={"flex-start"}
    >
      {targets.map((t, index) => (
        <Box
          key={t.TargetPeriodValue}
          sx={{ display: "flex", alignItems: "center", gap: "1.5rem" }}
        >
          <Typography variant="form_h1">
            Weight for {nameMap[t.TargetPeriodValue]}
          </Typography>
          <Input
            value={t.Weight}
            onChange={(value) => {
              onChangeHandler(value, "Weight", index);
            }}
            styles={{ width: "100%" }}
          />
        </Box>
      ))}
      <Box flex={1}></Box>
      <Button
        label={"Done"}
        onClick={() => {
          onDone(data);
        }}
      />
    </Stack>
  );
};

export default TargetsAndWeights;
